import { Skeleton } from '@/client/components/ui/skeleton';

/**
 * Generic route-transition fallback for pages without a bespoke skeleton
 * (user/portfolio, leaderboard): header row + filter pills + content blocks.
 */
export const PageSkeleton = () => (
  <section className="w-full min-h-full px-4 py-6 md:px-6">
    <div className="max-w-[1000px] mx-auto space-y-6">
      <div className="flex items-center gap-4">
        <Skeleton className="size-12 rounded-full flex-shrink-0" />
        <div className="flex-1 space-y-2">
          <Skeleton className="h-6 w-40" />
          <Skeleton className="h-4 w-24" />
        </div>
      </div>
      <div className="flex gap-3">
        <Skeleton className="h-9 w-24 rounded-full" />
        <Skeleton className="h-9 w-24 rounded-full" />
        <Skeleton className="h-9 w-24 rounded-full" />
      </div>
      <div className="space-y-3">
        {[0, 1, 2, 3].map(i => (
          <Skeleton key={i} className="h-16 w-full rounded-3" />
        ))}
      </div>
    </div>
  </section>
);
